/* ==========================================================================
   vein.js — the Pressure Vein controller.

   One <svg data-vein> per section, emitted by snippets/vein-path.liquid.
   Each carries three paths: a dormant base, a charge path whose dash offset
   is scrubbed by scroll depth, and a flow path whose dashes travel on a CSS
   loop that never stops. Sections share the same gutter geometry, so the
   separate paths read as one continuous line down the page.

   States: dormant -> charging -> pressurized, plus discharge, which is set
   declaratively in Liquid on the emergency band and the emergency page.
   ========================================================================== */

(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function measure(path) {
    try { return path.getTotalLength(); } catch (e) { return 0; }
  }

  function initSpurs(root) {
    root.querySelectorAll('.vein__spur-fill').forEach(function (spur) {
      spur.style.setProperty('--len', measure(spur) || 200);
    });
  }

  function initVein(svg) {
    var charge = svg.querySelector('.vein__charge');
    initSpurs(svg);

    if (!charge) return;

    var len = measure(charge);
    charge.style.strokeDasharray = len;

    if (reduce) {
      // Static, fully drawn, dormant. Still reads as a deliberate line.
      charge.style.display = 'none';
      return;
    }

    charge.style.strokeDashoffset = len;

    if (!window.gsap || !window.ScrollTrigger) {
      // No orchestration available: leave the line drawn rather than blank.
      charge.style.strokeDashoffset = 0;
      return;
    }

    var section = svg.closest('[data-vein-section]') || svg.parentElement;

    window.gsap.to(charge, {
      strokeDashoffset: 0,
      ease: 'none',
      scrollTrigger: {
        trigger: section,
        start: 'top 90%',
        end: 'bottom 40%',
        scrub: 0.6,
        onEnter: function () { setState(svg, 'charging'); },
        onLeave: function () { setState(svg, 'pressurized'); },
        onEnterBack: function () { setState(svg, 'charging'); },
        onLeaveBack: function () { setState(svg, 'dormant'); },
        onToggle: function (self) {
          // will-change is only worth paying for while the segment is live.
          charge.style.willChange = self.isActive ? 'stroke-dashoffset' : '';
        }
      }
    });
  }

  function setState(svg, state) {
    if (svg.dataset.veinLock === 'true') return; // discharge sections stay put
    svg.dataset.state = state;
  }

  function start() {
    document.querySelectorAll('[data-vein]').forEach(initVein);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  window.FortitudeVein = { refresh: start };
})();
